<template>
  <div v-if="consumerUnit && consumerUnit.id">
    <v-card>
      <v-list two-line subheader>
        <v-subheader class="grey lighten-3">
          <div>Dados da Unidade Consumidora</div>
        </v-subheader>
        <div class="pt-2 pl-3" v-if="consumerUnit.utility_company">
          <v-img
            :src="
              require(
                '@/assets/utility-company/' +
                  consumerUnit.utility_company +
                  '.png',
              )
            "
            max-width="120px"
          />
        </div>
        <v-list-tile avatar v-if="consumerUnit.name">
          <v-list-tile-content>
            <v-list-tile-sub-title>Nome do Titular</v-list-tile-sub-title>
            <v-list-tile-title>{{ consumerUnit.name }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-tooltip bottom v-if="consumerUnit.ownership">
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  ripple
                  :color="status.color"
                  round
                  class="white--text"
                  small
                  v-on="on"
                >
                  Trocou de Titular
                </v-btn>
              </template>
              <span>{{
                consumerUnit.ownership.previous +
                "-> " +
                consumerUnit.ownership.new
              }}</span>
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-btn
              v-if="permissions.edit_customer"
              icon
              ripple
              @click="
                editDialog = true;
                editTarget = 'name';
              "
            >
              <v-icon color="grey lighten-1" class="ml-5">edit</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="permissions.edit_cpf_cnpj"
                  icon
                  ripple
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    editCredentials = true;
                    editTarget = 'cpf';
                  "
                >
                  <v-icon color="grey lighten-1">mdi-account-convert</v-icon>
                </v-btn>
              </template>
              <span>Editar CPF/CNPJ</span>
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Número de Instalação</v-list-tile-sub-title>
            <v-list-tile-title>
              {{ consumerUnit.installation_number }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action
            v-if="
              consumerUnit.status === 'canceled' ||
              consumerUnit.status === 'canceling'
            "
          >
            <v-tooltip bottom max-width="300">
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  ripple
                  :color="status.color"
                  round
                  class="white--text"
                  small
                  v-on="on"
                >
                  {{ status.text }}
                </v-btn>
              </template>
              <div>
                <p>
                  {{ consumerUnit?.canceled_at | formatDateTime }} <br />{{
                    consumerUnit?.status_reason | formatStatusReason
                  }}
                </p>
                <span class="pb-3" v-if="consumerUnit.cancel_agent">
                  Cancelado por: {{ consumerUnit?.cancel_agent }} <br
                /></span>
                <span>{{
                  consumerUnit.status === "interrupted" ||
                  consumerUnit.status === "interrupting"
                    ? consumerUnit.status_reason_desc
                    : consumerUnit.status_reason_description || status.text
                }}</span>
              </div>
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-action v-else>
            <v-btn
              large
              ripple
              :color="status.color"
              round
              class="white--text"
              small
            >
              {{ status.text }}
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-action
            v-if="
              (consumerUnit.status === 'canceled' ||
                consumerUnit.status === 'canceling') &&
              consumerUnit.has_fine
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  ripple
                  color="red"
                  round
                  class="white--text"
                  small
                  :href="consumerUnit.fine_boleto_url"
                  target="_blank"
                  v-on="on"
                >
                  Multa Por Cancelamento
                </v-btn>
              </template>
              <span>Exibir Boleto</span>
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-action v-if="consumerUnit.comercial_status === true">
            <v-tooltip bottom max-width="300">
              <template v-slot:activator="{ on }">
                <v-chip
                  v-on="on"
                  :color="comercialStatus.color"
                  round
                  text-color="white"
                  small
                >
                  {{ comercialStatus.text }}
                </v-chip>
              </template>
              <span>
                Cliente PF com perfil de PJ, se enquadra como pequeno negócio
              </span>
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile
          avatar
          v-if="
            (consumerUnit.status === 'canceled' ||
              consumerUnit.status === 'canceling') &&
            consumerUnit.service_id
          "
        >
          <v-list-tile-content>
            <v-list-tile-sub-title>ID de atendimento</v-list-tile-sub-title>
            <v-list-tile-title>{{ consumerUnit.service_id }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout align-center justify-end row fill-height>
              <v-flex xs12 md6>
                <v-btn icon ripple @click="copyLink(consumerUnit.service_id)">
                  <v-icon color="grey lighten-1">content_copy</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar v-if="consumerUnit.qualification_agent">
          <v-list-tile-content>
            <v-list-tile-sub-title>Qualificado por</v-list-tile-sub-title>
            <v-list-tile-title
              v-if="consumerUnit?.qualification_agent == userCS?.email"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" style="cursor: default">
                    Auto qualificação
                  </span>
                </template>
                <span
                  >Qualificado pelo próprio cliente via PARSE da conta no
                  app.</span
                >
              </v-tooltip>
            </v-list-tile-title>
            <v-list-tile-title v-else>{{
              consumerUnit.qualification_agent
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar v-if="consumerUnit.qualification_at">
          <v-list-tile-content>
            <v-list-tile-sub-title>Data da qualificação</v-list-tile-sub-title>
            <v-list-tile-title>{{
              consumerUnit.qualification_at | formatDateTime
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Status de Alocação</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-chip :color="allocationStatus.color" text-color="white" small>
              {{ allocationStatus.text }}
            </v-chip>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Endereço</v-list-tile-sub-title>
            <v-list-tile-title>
              <div v-html="address" />
            </v-list-tile-title>
            <v-list-tile-title>
              <div v-html="address_complement" />
            </v-list-tile-title>
            <v-list-tile-title>
              <div v-html="address_postalcode" />
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon ripple @click="editAddressDialog = true">
              <v-icon color="grey lighten-1">edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Número do Membro</v-list-tile-sub-title>
            <v-list-tile-title>{{
              consumerUnit.customer_number
            }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn
              icon
              ripple
              @click="
                editDialog = true;
                editTarget = 'customer_number';
              "
            >
              <v-icon color="grey lighten-1">edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar v-if="consumerUnit.rate_class">
          <v-list-tile-content>
            <v-list-tile-sub-title>Classe</v-list-tile-sub-title>
            <v-list-tile-title>
              {{ consumerUnit.rate_class }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Concessionária</v-list-tile-sub-title>
            <v-list-tile-title>{{
              consumerUnit.utility_company | formatUtilityCompany
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-layout row wrap>
          <v-flex xs6>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title>Planta</v-list-tile-sub-title>
                <v-list-tile-title>
                  {{ consumerUnit.power_plant_id }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="
                    consumerUnit.utility_sent_info &&
                    consumerUnit.power_plant_id !==
                      consumerUnit.utility_sent_info.power_plant_id
                  "
                >
                  Expectativa:
                  {{ consumerUnit.utility_sent_info.power_plant_id }} 🠖
                  {{ consumerUnit.utility_sent_info.expected_competence }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-flex>

          <v-flex xs6>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title
                  >Percentual de Locação</v-list-tile-sub-title
                >
                <v-list-tile-title>
                  {{ consumerUnit.percentage }}%
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-flex>
        </v-layout>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Percentual de Desconto</v-list-tile-sub-title
            >
            <v-list-tile-title v-if="consumerUnit.discount_type === 'kwh'">
              Tarifa Fixa: R$ {{ consumerUnit.fixed_rate | formatCurrency }}
            </v-list-tile-title>
            <v-list-tile-title
              v-else-if="consumerUnit.plan && consumerUnit.plan.discount"
            >
              {{ consumerUnit.plan.discount }}%
            </v-list-tile-title>
            <v-list-tile-title v-else>
              {{ consumerUnit.percentage_discount }}%
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Plano Vigente</v-list-tile-sub-title>
            <v-list-tile-title
              v-if="
                consumerUnit.plan &&
                (consumerUnit.plan.id || consumerUnit.plan.name)
              "
            >
              {{ consumerUnit.plan.name || consumerUnit.plan.id }} | Tempo de
              Contrato: {{ consumerUnit.plan.contract_time }} meses
            </v-list-tile-title>
            <v-list-tile-title v-else> SEM PLANO </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="permissions.change_plan_uc">
            <v-btn v-if="consumerUnit.plan" icon ripple @click="changePlan">
              <v-icon color="grey lighten-1">edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Balanço Financeiro</v-list-tile-sub-title>
            <v-list-tile-title>
              R$
              {{
                consumerUnit.account_balance
                  ? consumerUnit.account_balance.toFixed(2).replace(".", ",")
                  : "0,00"
              }}
            </v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <div v-if="loadingPermission" class="text-center">
              <v-progress-circular
                :width="2"
                :size="20"
                color="grey ligthen-1"
                indeterminate
              ></v-progress-circular>
            </div>
            <v-layout v-else align-center justify-end row fill-height>
              <v-flex xs12 md6>
                <v-btn
                  v-if="canChangeAccountBalance"
                  icon
                  ripple
                  @click="editBalance = true"
                >
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 md6>
                <v-btn
                  icon
                  ripple
                  v-if="
                    accountBalanceHistory && accountBalanceHistory.length >= 0
                  "
                  @click="accountBalanceHistoryDialog = true"
                >
                  <v-icon color="grey lighten-1">view_list</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar v-if="consumerUnit.billing_competence_start">
          <v-list-tile-content>
            <v-list-tile-sub-title>Inicio de Faturamento</v-list-tile-sub-title>
            <v-list-tile-title>
              {{
                consumerUnit.billing_competence_start | formatCompetenceTraco
              }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar v-if="consumerUnit.billing_competence_end">
          <v-list-tile-content>
            <v-list-tile-sub-title>Fim de Faturamento</v-list-tile-sub-title>
            <v-list-tile-title>
              {{ consumerUnit.billing_competence_end | formatCompetenceTraco }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar v-if="consumerUnit.contract_id">
          <v-list-tile-content>
            <v-list-tile-sub-title>
              Contrato
              <span
                :class="
                  'font-weight-bold ' +
                  (consumerUnit.constract_type === 'internal'
                    ? 'green--text'
                    : 'blue--text')
                "
              >
                {{
                  consumerUnit.constract_type === "internal"
                    ? "online"
                    : "autentique"
                }}
              </span>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout align-center justify-end row fill-height>
              <v-flex x12 md6>
                <v-btn
                  icon
                  ripple
                  @click="
                    downloadContracts(
                      consumerUnit.contract_url,
                      consumerUnit.id,
                    )
                  "
                  target="_blank"
                  v-if="consumerUnit.constract_type === 'internal'"
                >
                  <v-icon dark right large color="green lighten-1"
                    >history_edu</v-icon
                  >
                </v-btn>
                <v-btn icon ripple :href="contract_id" target="_blank" v-else>
                  <v-icon dark right large color="blue lighten-1"
                    >history_edu</v-icon
                  >
                </v-btn>
              </v-flex>
              <v-flex x12 md6 v-if="contracts.length > 0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      large
                      dark
                      color="grey lighten-2"
                      @click="contractsDialog = true"
                    >
                      view_list</v-icon
                    >
                  </template>
                  <span>Lista dos contratos</span>
                </v-tooltip>
              </v-flex>
              <v-flex
                x12
                md6
                v-if="
                  consumerUnit.sign_url &&
                  consumerUnit.status === 'awaiting_signature'
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      medium
                      dark
                      color="grey lighten-2"
                      @click="copyLink(consumerUnit.sign_url)"
                    >
                      file_copy</v-icon
                    >
                  </template>
                  <span>Copiar link de assinatura</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>
        <!-- unique_billing -->
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Conta única</v-list-tile-sub-title>
            <v-list-tile-title>
              {{ consumerUnit.unique_billing ? "Sim" : "Não" }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action
            v-if="!this.user.group.includes('external_collection')"
          >
            <v-layout row>
              <v-flex>
                <v-btn
                  icon
                  riple
                  @click="editUniqueBilling = true"
                  v-if="
                    (userCS.payment_type === 'boleto' &&
                      consumerUnit.status !== 'canceled' &&
                      consumerUnit.status !== 'canceling' &&
                      consumerUnit.status !== 'interrupted') ||
                    consumerUnit.unique_billing == true
                  "
                >
                  <v-icon
                    dark
                    right
                    color="black lighten-1"
                    v-if="!consumerUnit.unique_billing"
                  >
                    radio_button_unchecked
                  </v-icon>
                  <v-icon dark right color="black darken-1" v-else>
                    radio_button_checked
                  </v-icon>
                </v-btn>
              </v-flex>
              <v-flex>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="showAccountUnificationHistory"
                    >
                      <v-icon dark right color="black darken-1">
                        mdi-format-list-bulleted
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar histórico</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-dialog
          v-model="accountUnificationHistoryDialog"
          persistent
          lazy
          max-width="1000px"
        >
          <v-card
            class="d-flex dialog-container"
            style="flex-direction: column"
          >
            <v-card-title class="title font-weight-bold pb-0 dialog-header">
              Histórico de alterações de contas unificadas e desunificadas
              <v-spacer></v-spacer>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="showAccountUnificationHistory"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="dialog-content">
              <v-timeline align-top dense>
                <v-timeline-item
                  v-for="history in consumerUnit.account_unification_history"
                  :key="history.id"
                  color="#7D3DFF"
                  small
                >
                  <v-layout pt-2>
                    <div>
                      <strong style="font-size: inherit">{{
                        history.action
                      }}</strong>
                      por
                      <strong style="font-size: inherit">{{
                        history.agent_email
                      }}</strong>
                      em
                      <strong style="font-size: inherit">{{
                        history.created_at | formatDateTime
                      }}</strong>
                      <span
                        v-if="
                          history.old_payment_type && history.new_payment_type
                        "
                      >
                        <strong style="font-size: inherit"
                          >. {{ history.old_payment_type }}</strong
                        >
                        <v-icon color="#7D3DFF" style="vertical-align: middle">
                          east
                        </v-icon>
                        <strong style="font-size: inherit">
                          {{ history.new_payment_type }}</strong
                        >
                      </span>
                    </div>
                  </v-layout>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-list-tile
          avatar
          v-if="!this.user.group.includes('external_collection')"
        >
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Sem saldo para Cobrança Juntos</v-list-tile-sub-title
            >
            <v-list-tile-title>
              {{ consumerUnit.without_balance ? "Sim" : "Não" }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon riple @click="editWithoutBalance = true">
              <v-icon
                dark
                right
                color="black lighten-1"
                v-if="!consumerUnit.without_balance"
              >
                radio_button_unchecked
              </v-icon>
              <v-icon dark right color="black darken-1" v-else>
                radio_button_checked
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile
          avatar
          v-if="!this.user.group.includes('external_collection')"
        >
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Fornecimento Duplicado</v-list-tile-sub-title
            >
            <v-list-tile-title>
              {{ consumerUnit.duplicated_supply ? "Sim" : "Não" }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout row justify-end>
              <v-flex md6>
                <v-btn icon riple @click="editDuplicatedSupply = true">
                  <v-icon
                    dark
                    right
                    color="black lighten-1"
                    v-if="!consumerUnit.duplicated_supply"
                  >
                    radio_button_unchecked
                  </v-icon>
                  <v-icon dark right color="black darken-1" v-else>
                    radio_button_checked
                  </v-icon>
                </v-btn>
              </v-flex>
              <v-flex md6 v-if="changeDuplicatedSupplyHistory">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="showChangeDuplicatedSupplyHistory = true"
                    >
                      <v-icon dark right color="black darken-1">
                        mdi-format-list-bulleted
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar histórico</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile
          avatar
          v-if="!this.user.group.includes('external_collection')"
        >
          <v-list-tile-content>
            <v-list-tile-sub-title>UC sob análise</v-list-tile-sub-title>
            <v-list-tile-title>
              <span v-if="!consumerUnit.under_analysis">Não</span>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <span v-on="on"> Sim </span>
                </template>
                <span>{{
                  consumerUnit.under_analysis_reason | formatAnalysisReason
                }}</span>
              </v-tooltip>
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout row>
              <v-flex>
                <v-btn icon ripple @click="editUnderAnalysis = true">
                  <v-icon
                    dark
                    right
                    color="black lighten-1"
                    v-if="!consumerUnit.under_analysis"
                  >
                    radio_button_unchecked
                  </v-icon>
                  <v-icon dark right color="black darken-1" v-else>
                    radio_button_checked
                  </v-icon>
                </v-btn>
              </v-flex>
              <v-flex>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="showAnalysisHistoryDialog"
                    >
                      <v-icon dark right color="black darken-1">
                        mdi-format-list-bulleted
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar histórico</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-dialog v-model="analysisHistoryDialog" persistent max-width="800px">
          <v-card
            class="d-flex dialog-container"
            style="flex-direction: column"
          >
            <v-card-title class="title font-weight-bold pb-0 dialog-header">
              Histórico de alterações de análise da UC
              <v-spacer></v-spacer>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="showAnalysisHistoryDialog"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="dialog-content">
              <v-list>
                <v-list-item
                  v-for="history in consumerUnit.under_analysis_history"
                  :key="history.id"
                >
                  <v-list-item-content>
                    <div>
                      <strong style="font-size: inherit">{{
                        history.action
                      }}</strong>
                      por
                      <strong style="font-size: inherit">{{
                        history.agent_email
                      }}</strong>
                      em
                      <strong style="font-size: inherit">{{
                        history.created_at | formatDateTime
                      }}</strong>
                      <br />
                      <span v-if="history.under_analysis_reason">
                        Motivo:
                        <strong style="font-size: inherit">{{
                          history.under_analysis_reason | formatAnalysisReason
                        }}</strong>
                      </span>
                      <span v-if="history.under_analysis_comments">
                        Observação:
                        <strong style="font-size: inherit">{{
                          history.under_analysis_comments
                        }}</strong>
                      </span>
                    </div>
                    <br />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="editUnderAnalysis" max-width="500px">
          <v-card class="py-3 px-1">
            <v-card-title class="pb-0">
              <div
                v-if="!consumerUnit.under_analysis"
                class="title font-weight-bold mx-auto"
              >
                Deseja colocar esta UC em análise?
              </div>
              <div v-else class="title font-weight-bold mx-auto">
                Deseja retirar esta UC de análise?
              </div>
            </v-card-title>
            <v-card-text class="px-5">
              <v-autocomplete
                v-model="under_analysis_reason"
                :items="reasonsList"
                item-text="text"
                item-value="value"
                label="Motivo"
                :readonly="consumerUnit.under_analysis"
              />
              <v-textarea
                label="Observações"
                v-model="under_analysis_comments"
                type="text"
                class="purple-input"
                rows="1"
                :readonly="consumerUnit.under_analysis"
              />
            </v-card-text>
            <v-card-actions>
              <div class="mx-auto">
                <v-btn
                  color="red"
                  text
                  @click="editUnderAnalysis = false"
                  :disabled="loading_under_analysis"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="green"
                  text
                  @click="
                    setUnderAnalysis(
                      consumerUnit,
                      consumerUnit.under_analysis ? false : true,
                    )
                  "
                  :loading="loading_under_analysis"
                  >Confirmar</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="editDuplicatedSupply" max-width="500px">
          <v-card>
            <v-card-title class="`headline white--text`" primary-title>
              <span>
                Atenção: Tem certeza que deseja realizar esta alteração?
              </span>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" @click="editDuplicatedSupply = false"
                >NÃO</v-btn
              >
              <v-btn
                color="green"
                @click="
                  setDuplicatedSupply(
                    consumerUnit.id,
                    consumerUnit.duplicated_supply ? false : true,
                  )
                "
                >SIM</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="editWithoutBalance" max-width="500px">
          <v-card>
            <v-card-title class="`headline white--text`" primary-title>
              <span>
                Atenção: Tem certeza que deseja realizar esta alteração?
              </span>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" @click="editWithoutBalance = false">NÃO</v-btn>
              <v-btn
                color="green"
                @click="
                  setWithoutBalance(
                    consumerUnit.id,
                    consumerUnit.without_balance ? false : true,
                  )
                "
                >SIM</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-list>
      <v-flex
        sm12
        xs12
        md12
        v-if="
          consumerUnit.status !== 'canceled' &&
          consumerUnit.status !== 'canceling' &&
          consumerUnit.status !== 'interrupted'
        "
      >
        <div class="text-lg-center">
          <v-btn v-if="consumerUnits.length > 1" color="error" @click="multa()"
            >Cancelar</v-btn
          >
        </div>
      </v-flex>
      <v-flex
        sm12
        xs12
        md12
        v-if="
          consumerUnit.status !== 'canceled' &&
          consumerUnits.length > 1 &&
          permissions.force_uc_cancellation
        "
      >
        <div class="text-lg-center">
          <v-btn color="black" @click="showforceUcCancellation(consumerUnit)"
            >Forçar Cancelamento</v-btn
          >
        </div>
      </v-flex>
      <v-flex
        sm12
        xs12
        md12
        v-if="
          consumerUnit.status === 'canceled' ||
          consumerUnit.status === 'interrupted'
        "
      >
        <div class="text-lg-center">
          <v-btn
            v-if="consumerUnits.length > 1"
            color="green"
            @click="consumerUnitDialog = true"
            >Reativar</v-btn
          >
        </div>
      </v-flex>
    </v-card>

    <v-dialog v-model="forceCancellationDialog" max-width="500px" persistent>
      <v-card class="py-3 px-1">
        <v-card-title class="pb-0">
          <div class="title font-weight-bold mx-auto">
            Tem certeza que deseja forçar o cancelamento da UC?
          </div>
        </v-card-title>
        <v-card-text class="px-5">
          <v-form ref="changeAbono" v-if="filteredBillings?.length > 0">
            <div>Selecione a(s) fatura(s) para ser(em) abonada(s).</div>
            <v-select
              v-model="setStatusFree"
              :items="filteredBillings"
              :item-text="selectText"
              return-object
              label="Fatura"
              :rules="[(v) => !!v || 'Por favor selecione uma(s) fatura(s).']"
              multiple
              chips
              no-data-text="Não há fatura(s) para abonar"
            ></v-select>
            <v-textarea
              v-model="free_reason"
              placeholder="Escreva o motivo para abonar a(s) fatura(s)"
              rows="1"
              label="Motivo do Abono"
              type="text"
              class="purple-input"
            ></v-textarea>
          </v-form>
          <v-textarea
            v-model="forced_cancellation_reason_description"
            placeholder="Escreva o motivo do cancelamento"
            rows="1"
            label="Motivo do Cancelamento"
            type="text"
            class="purple-input"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn
              color="red"
              text
              @click="forceCancellationDialog = false"
              :disabled="loading_force_uc_cancellation"
              >Cancelar</v-btn
            >
            <v-btn
              color="green"
              text
              @click="forceUcCancellation(consumerUnit)"
              :loading="loading_force_uc_cancellation"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Editar informação da unidade consumidora</span>
        </v-card-title>
        <v-card-text>
          <v-form :ref="editTarget" v-if="editTarget == 'name'">
            <v-text-field
              label="Nome do titular"
              prepend-icon="star_border"
              :value="consumerUnit.name"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo nome do titular"
              prepend-icon="star"
              v-model="editValue"
            ></v-text-field>
          </v-form>
          <v-form :ref="editTarget" v-if="editTarget == 'percentage_discount'">
            <v-text-field
              label="Percentual"
              prepend-icon="star_border"
              :value="consumerUnit[editTarget]"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo Percentual"
              prepend-icon="star"
              name="editValue"
              hint="Somente números"
              counter
              :rules="[
                (v) =>
                  !!v || 'Por favor, informe o novo percentual de desconto.',
                (v) => v.length <= 2 || 'Porcentagem deve ser um valor válido!',
              ]"
              required
              v-model="editValue"
              :mask="editValue.length >= 2 ? '##%' : '#%#'"
            ></v-text-field>
          </v-form>
          <v-form :ref="editTarget" v-if="editTarget == 'customer_number'">
            <v-text-field
              label="Número do Membro"
              prepend-icon="star_border"
              :value="consumerUnit[editTarget]"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo Número do Membro"
              prepend-icon="star"
              name="editValue"
              hint="Somente números"
              counter
              :rules="[
                (v) => !!v || 'Por favor, informe o novo número do membro.',
              ]"
              required
              v-model="editValue"
              type="number"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="editDialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="changeConsumerUnit"
            :disabled="loadingChange"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editCredentials" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Editar informação da unidade consumidora</span>
        </v-card-title>
        <v-card-text>
          <v-form :ref="editTarget" v-if="consumerUnit.person_type === 'pj'">
            <v-text-field
              label="CNPJ"
              prepend-icon="star_border"
              :value="consumerUnit.cpf"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo CNPJ"
              prepend-icon="star"
              v-model="editValue"
            ></v-text-field>
          </v-form>
          <v-form :ref="editTarget" v-if="consumerUnit.person_type === 'pf'">
            <v-text-field
              label="CPF"
              prepend-icon="star_border"
              :value="consumerUnit.cpf"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo CPF"
              prepend-icon="star"
              v-model="editValue"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="
              editCredentials = false;
              editValue = '';
            "
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="changeCredentials"
            :disabled="!permissions.edit_cpf_cnpj"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="editBalance"
      v-model="editBalance"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline"
            >Editar balanço financeiro da unidade consumidora</span
          >
        </v-card-title>
        <v-card-text>
          <v-form ref="accountBalanceForm" v-model="valid" lazy-validation>
            <v-select
              v-model="accountBalanceType"
              :items="accountBalanceTypes"
              item-text="text"
              item-value="value"
              label="Tipo"
              required
              :rules="[rules.required]"
            >
            </v-select>
            <v-text-field
              v-model="accountBalance"
              label="Valor à ser adicionado"
              hint="Somente números"
              required
              :rules="[rules.required, rules.onlyNumbers]"
            ></v-text-field>

            <v-autocomplete
              v-model.lazy="accountBalanceCategory"
              :items="filteredBalanceCategories"
              item-text="text"
              return-object
              label="Categoria"
              no-data-text="Não existe essa categoria"
              required
              :rules="[rules.required]"
            >
            </v-autocomplete>
            <v-textarea
              box
              v-model="accountBalanceDescription"
              placeholder="Atenção! Este é o texto que vai aparecer no demonstrativo"
              hint="Atenção! Este é o texto que vai aparecer no demonstrativo"
              :counter="50"
              required
              :rules="[rules.required]"
              maxlength="50"
            ></v-textarea>

            <v-textarea
              box
              v-model="accountBalanceReason"
              placeholder="Nota Interna"
              height="70"
              no-resize
              required
              :rules="[rules.requiredNote, rules.minLength]"
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="editBalance = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="changeAccountBalance"
            :disabled="!permissions.change_bonus_uc"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelDialog" max-width="500px">
      <v-card dark>
        <v-card-title class="headline red white--text" primary-title>
          Atenção: Tem certeza que deseja cancelar esta unidade consumidora?
        </v-card-title>
        <v-card-actions class="align">
          <v-card-title v-if="hasFine == true">
            <v-card-text>
              <span>
                OBS: Essa unidade consumidora possui uma multa no valor de:
                <span class="font-weight-bold"
                  >R$
                  {{
                    valorMulta.toString().split(".")[0] +
                    "," +
                    valorMulta.toString().split(".")[1].substring(0, 2)
                  }}</span
                ></span
              >
              <br />
              <br />
              <span>
                Tempo de contrato:
                <span class="font-weight-bold"
                  >{{ tempoContrato }} meses</span
                ></span
              >
              <br />
              <br />
              <span>
                Tempo ativo:
                <span class="font-weight-bold"
                  >{{ tempoAtivo }} meses</span
                ></span
              >
              <br />
              <br />
              <span>
                Quantidade de meses considerados para cálculo da multa:
                <span class="font-weight-bold"
                  >{{ mesesMulta }} meses</span
                ></span
              >
            </v-card-text>
          </v-card-title>
        </v-card-actions>
        <v-card-text v-if="consumerUnit">
          <v-form ref="consumerUnitStatus">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 lg6>
                  <v-btn round outline>{{ consumerUnit.id }}</v-btn>
                </v-flex>
                <v-flex xs12 lg6>
                  <v-select
                    prepend-inner-icon="flag"
                    :items="cancelReasons"
                    v-model="reason"
                    item-text="text"
                    item-value="value"
                    placeholder="Motivo"
                    :rules="[(v) => !!v || 'Motivo é obrigatório!']"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-text-field
                v-model.number="serviceId"
                placeholder="ID de atendimento"
                :rules="[
                  (v) => !!v || 'Por favor, informe o ID de atendimento.',
                  (v) => /^[0-9]*$/.test(v) || 'Apenas números são permitidos.',
                ]"
                required
              ></v-text-field>
              <v-textarea
                box
                name="description"
                v-model="reasonDescription"
                placeholder="Escreva a descrição do motivo do cancelamento..."
                :rules="[
                  (v) =>
                    !!v ||
                    'Por favor, informe uma descrição do motivo de cancelamento.',
                ]"
                required
              ></v-textarea>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="cancelDialog = false">NÃO</v-btn>
          <v-btn
            color="red"
            @click="cancelConsumerUnitProcess"
            :disabled="loadingChange"
            :loading="loadingChange"
            >SIM</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="reactivateDialog" max-width="500px">
      <v-card dark>
        <v-card-title class="headline red white--text" primary-title>
          Atenção: Tem certeza que deseja reativar esta unidade consumidora?
        </v-card-title>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="reactivateDialog = false"
            >NÃO</v-btn
          >
          <v-btn
            color="green"
            @click="reactivateConsumerUnitProcess"
            :disabled="loadingChange"
            :loading="loadingChange"
            >SIM</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editAddressDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Editar endereço da unidade consumidora</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="consumerUnit.address.postal_code"
                  label="CEP"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newPostalCode"
                  label="Novo CEP"
                  :hint="'Informe o CEP'"
                  mask="#####-###"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="consumerUnit.address.address"
                  label="Endereço"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newAddress"
                  label="Novo Endereço"
                  :hint="'Informe o Endereço'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="consumerUnit.address.address_number"
                  label="Número"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newAddressNumber"
                  label="Novo Número"
                  :hint="'Informe o Número'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="consumerUnit.address.address_complement"
                  label="Complemento"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newAddressComplement"
                  label="Novo Complemento"
                  :hint="'Informe o Complemento'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="consumerUnit.address.district"
                  label="Bairro"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newDistrict"
                  label="Bairro"
                  :hint="'Informe o Bairro'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="consumerUnit.address.city"
                  label="Cidade"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newCity"
                  label="Cidade"
                  :hint="'Informe a Cidade'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="editAddressDialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="changeAddress"
            :disabled="loadingChange"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editUniqueBilling" max-width="500px">
      <v-card>
        <v-card-title class="`headline white--text`" primary-title>
          <span
            v-if="
              userCS.payment_type === 'credit_card' &&
              !consumerUnit.unique_billing
            "
            class="red--text"
          >
            O método de pagamento atual é cartão de crédito. Não é possível
            realizar a alteração!
          </span>
          <span v-else>
            Atenção: Tem certeza que deseja
            {{ !consumerUnit.unique_billing ? "realizar" : "cancelar" }} a
            unificação da conta?
          </span>
        </v-card-title>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="grey" @click="editUniqueBilling = false">NÃO</v-btn>
          <v-btn
            color="red"
            @click="
              setUniqueBilling(consumerUnit.id, !consumerUnit.unique_billing)
            "
            :disabled="
              loadingChange ||
              (userCS.payment_type === 'credit_card' &&
                !consumerUnit.unique_billing)
            "
            :loading="loadingChange"
            >SIM</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="consumerUnitDialog" persistent max-width="1200px">
      <v-card>
        <v-card-title>
          Unidade Consumidora que será reativada
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            flat
            color="error"
            @click="consumerUnitDialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list three-line>
            <v-list-tile>
              <v-list-tile-action>
                <v-checkbox v-model="uc_checkbox" readonly></v-checkbox>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  consumerUnit.installation_number
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  consumerUnit.address.address
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            :loading="loading_qualification"
            :disabled="loading_qualification"
            @click="ucs_selected(consumerUnit)"
            >Qualificar</v-btn
          >
        </v-card-actions>
        <v-spacer></v-spacer>
        <v-flex
          xs12
          sm12
          md12
          v-if="qualifications && qualifications.length > 0"
        >
          <v-list three-line>
            <template v-for="(qualification, idx) in qualifications">
              <qualifying-card
                :key="idx"
                :qualification="qualification"
                v-if="qualification.status === 'pending'"
              />
              <not-qualified-card
                :key="idx"
                :qualification="qualification"
                v-if="
                  qualification.status === 'bill_not_found' ||
                  qualification.status === 'error'
                "
              />
              <disqualified-card
                :key="idx"
                :qualification="qualification"
                v-if="qualification.status === 'disqualified'"
              />
              <qualified-card
                :key="idx"
                :qualification="qualification"
                v-if="qualification.status === 'qualified'"
              />
            </template>
          </v-list>
        </v-flex>
        <v-card v-if="qualifications && qualifications.length > 0">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              :loading="loading_qualification"
              :disabled="loading_qualification"
              @click="finishQualificationProcess(userCS)"
              >Reativar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="contractsDialog" persistent max-width="1200px">
      <v-card>
        <v-card-title>
          Lista de Contratos da Unidade Consumidora {{ consumerUnit.id }}
          <v-spacer></v-spacer>
          <v-btn icon dark flat color="error" @click="contractsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-data-table
          :headers="contractHeaders"
          :items="contracts"
          :pagination.sync="contractPagination"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{
                (props.item.contract_created_at || props.item.created_at)
                  | formatDateTime
              }}
            </td>
            <td class="text-xs-center">
              <v-chip
                :color="props.item.status | formatContractStatusColor"
                text-color="white"
              >
                {{ props.item.status | formatContractStatus }}
              </v-chip>
            </td>
            <td class="text-xs-center">
              <v-btn
                icon
                ripple
                @click="
                  downloadContracts(props.item.contract_url, props.item.id)
                "
                target="_blank"
                v-if="props.item.constract_type === 'internal'"
              >
                <v-icon dark right large color="green lighten-1"
                  >history_edu</v-icon
                >
              </v-btn>
              <v-btn
                icon
                ripple
                :href="
                  (props.item.contract_id || props.item.id) | formatContractURL
                "
                target="_blank"
                v-else
              >
                <v-icon dark right large color="blue lighten-1"
                  >history_edu</v-icon
                >
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="changeDuplicatedSupplyHistory"
      v-model="showChangeDuplicatedSupplyHistory"
      persistent
      lazy
      max-width="1000px"
    >
      <v-card class="d-flex dialog-container" style="flex-direction: column">
        <v-card-title class="title font-weight-bold pb-0 dialog-header">
          Histórico de alterações de fornecimento duplicado da unidade
          consumidora
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            flat
            color="error"
            @click="showChangeDuplicatedSupplyHistory = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="dialog-content">
          <v-timeline align-top dense>
            <v-timeline-item
              v-for="(history, i) in changeDuplicatedSupplyHistory"
              :key="i"
              color="#7D3DFF"
              small
            >
              <v-layout pt-2>
                <v-flex xs4>
                  <v-layout column>
                    <v-flex>
                      <span
                        :class="`subheading font-weight-bold black--text`"
                        >{{ history.created_at | formatDateTime }}</span
                      >
                    </v-flex>
                    <v-flex>
                      <span
                        :class="`caption font-weight-bold black--text`"
                        v-text="`Alterado por: `"
                      ></span>
                      <span
                        :class="`caption font-weight-light black--text`"
                        v-text="history.agent.email"
                      ></span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex>
                  <span
                    v-if="history.new_values.duplicated_supply"
                    :class="`font-weight-bold mb-3 black--text`"
                  >
                    UC marcada como fornecimento duplicado
                  </span>
                  <span v-else :class="`font-weight-bold mb-3 black--text`">
                    UC desmarcada como fornecimento duplicado
                  </span>
                  <div v-if="history.reason">
                    <span
                      :class="`caption font-weight-bold black--text`"
                      v-text="`Motivo: `"
                    ></span>
                    <span
                      :class="`caption font-weight-light black--text`"
                      v-text="history.reason"
                    ></span>
                  </div>
                </v-flex>
              </v-layout>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.value"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :top="snackbar.top"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn color="white" flat @click="snackbar.value = false">Fechar</v-btn>
    </v-snackbar>

    <ChangeUcPlanModal
      ref="changeUcPlan"
      :consumer_unit="consumerUnit"
      :user="user"
      @showSnackBar="showSnackBar"
    >
    </ChangeUcPlanModal>

    <account-balance-history
      v-if="accountBalanceHistoryDialog"
      :dialog="accountBalanceHistoryDialog"
      :consumerUnit="consumerUnit.id"
      :accountBalances="consumerUnit.account_balances"
      :history="accountBalanceHistory"
      @closeDialog="accountBalanceHistoryDialog = $event"
    />
  </div>
</template>

<script>
import firebase from "firebase";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import firestore from "../../../firebase/firestore";
import { hasPermissionMixin } from "../../../mixin/permissionsMixin";
import { getFine, removeTransaction } from "../../../services/billing";
import { addAccountBalance } from "../../../services/bonus";
import {
  cancelConsumerUnit,
  getConsumerUnitChangelog,
  reactivateConsumerUnit,
  updateConsumerUnit,
  updateConsumerUnitCore,
} from "../../../services/consumer_units";
import { getPermission } from "../../../services/permissions";
import {
  finishQualification,
  initQualification,
} from "../../../services/qualification";
import ChangeUcPlanModal from "../../customer/ChangeUcPlanModal.vue";
import DisqualifiedCard from "../../sales/qualification/DisqualifiedCard.vue";
import NotQualifiedCard from "../../sales/qualification/NotQualifiedCard.vue";
import QualifiedCard from "../../sales/qualification/QualifiedCard.vue";
import QualifyingCard from "../../sales/qualification/QualifyingCard.vue";
import AccountBalanceHistory from "./AccountBalanceHistory.vue";

export default {
  components: {
    QualifiedCard,
    DisqualifiedCard,
    QualifyingCard,
    NotQualifiedCard,
    ChangeUcPlanModal,
    AccountBalanceHistory,
  },

  mixins: [hasPermissionMixin],

  data() {
    return {
      agent_email: null,
      loadingChange: false,
      editCredentials: false,
      editDialog: false,
      editBalance: false,
      valorMulta: "",
      tempoContrato: "",
      tempoAtivo: "",
      mesesMulta: "",
      hasFine: false,
      cancelDialog: false,
      consumerUnitDialog: false,
      reactivateDialog: false,
      editAddressDialog: false,
      editUniqueBilling: false,
      editDuplicatedSupply: false,
      editWithoutBalance: false,
      editUnderAnalysis: false,
      under_analysis_reason: null,
      under_analysis_comments: null,
      loading_under_analysis: false,
      duplicated_supply: false,
      without_balance: false,
      uc_checkbox: true,
      loading_qualification: false,
      qualification_ids: [],
      editTarget: "",
      editValue: "",
      newPostalCode: "",
      newAddress: "",
      newAddressNumber: "",
      newAddressComplement: "",
      newDistrict: "",
      newCity: "",
      reasonsList: [],
      cancelReasons: [
        { text: "Mudou de concessionária", value: "new_utility_company" },
        { text: "Instalou painel próprio", value: "own_panel" },
        { text: "Fornecimento Duplicado", value: "duplicated_supply" },
        { text: "Mudou o consumo abaixo do mínimo", value: "low_consumption" },
        { text: "Mudou para baixa renda", value: "low_income" },
        {
          text: "Deseja receber boleto impresso",
          value: "receive_printed_invoice",
        },
        {
          text: "Impossibilidade de alteração da data de pagamento;",
          value: "cant_change_payment_date",
        },
        { text: "Desconto insuficiente", value: "insufficient_discount" },
        { text: "Inadimplência", value: "non_payment" },
        {
          text: "Cancelado na concessionária",
          value: "utility_company_canceled",
        },
        { text: "Mudou de Endereço", value: "address_changed" },
        { text: "Contrato Rejeitado", value: "rejected_contract" },
        { text: "Análise de Adesão", value: "sale_analysis" },
        { text: "Demora no Fornecimento", value: "supply_delay" },
        { text: "Conta CEMIG retida", value: "retained_account" },
        { text: "Solicitação do jurídico", value: "legal_request" },
        { text: "Contas separadas", value: "separate_accounts" },
        { text: "Desistência (7 dias)", value: "gave_up" },
        { text: "Aderiu ao concorrente", value: "competitor" },
      ],
      reason: null,
      reasonDescription: "",
      serviceId: null,
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
      uniqueBilling: false,
      contractsDialog: false,
      contractHeaders: [
        {
          text: "Data de Geração",
          align: "center",
          value: "contract_created_at",
        },
        {
          text: "Status",
          align: "center",
          value: "status",
        },
        {
          text: "Link do Contrato",
          align: "center",
          value: "contract_id",
        },
      ],
      contractPagination: {
        rowsPerPage: 20,
      },
      loadingPermission: false,
      canChangeAccountBalance: false,
      accountBalanceHistoryDialog: false,
      accountBalance: "",
      accountBalanceReason: "",
      accountBalanceDescription: "",
      accountBalanceCategory: "",
      accountBalanceType: "",
      accountBalanceTypes: [
        { text: "Bônus", value: "bonus" },
        { text: "Cobrança Futura", value: "charge" },
      ],
      accountBalanceCategories: [
        //Bônus
        {
          text: "Pagamento em duplicidade",
          value: "duplicated_payment",
          type: "bonus",
        },
        { text: "Marketing", value: "marketing", type: "bonus" },
        {
          text: "Juros de concessionária",
          value: "utility_interest",
          type: "bonus",
        },
        { text: "Pagamento maior", value: "greater_payment", type: "bonus" },
        { text: "Retenção", value: "retention", type: "bonus" },
        //Cobrança Futura
        {
          text: "Pagamento a menor realizado em",
          value: "minor_payment",
          type: "charge",
        },
        {
          text: "Repasse indevido para a concessionária",
          value: "wrong_transfer",
          type: "charge",
        },
        { text: "Fatura", value: "not_billed", type: "charge" },
        {
          text: "Refaturamento da concessionária",
          value: "utility_rebilling",
          type: "charge",
        },
      ],
      forceCancellationDialog: false,
      loading_force_uc_cancellation: false,
      forced_cancellation_reason_description: null,
      free_reason: "",
      setStatusFree: [],
      plans: [],
      analysisHistoryDialog: false,
      accountUnificationHistoryDialog: false,
      rate_classes: ["Monofásico", "Bifásico", "Trifásico"],
      valid: true,
      rules: {
        required: (v) => !!v || "Campo obrigatório",
        requiredNote: (v) => !!v || "Por favor, informe a nota interna",
        minLength: (v) =>
          (v && v.length >= 20) ||
          "Nota interna deve ter no mínimo 20 caracteres.",
        onlyNumbers: (v) =>
          (v && !!v.replace(",", ".").match(/^\d+([.,]\d+)?$/)) ||
          "O valor só pode ser número!",
      },
      changeDuplicatedSupplyHistory: null,
      showChangeDuplicatedSupplyHistory: false,
    };
  },

  async created() {
    this.agent_email = this.user?.email || null;
    this.updatePlans();
    this.fetchReasons();

    const changelog = await getConsumerUnitChangelog(this.consumerUnit.id);
    const change_duplicated_supply_history = changelog.filter((change) =>
      change.fields_changed.includes("duplicated_supply"),
    );

    if (change_duplicated_supply_history.length > 0)
      this.changeDuplicatedSupplyHistory = change_duplicated_supply_history;
    else this.changeDuplicatedSupplyHistory = null;

    this.loadingPermission = true;
    this.canChangeAccountBalance = await this.hasPermission("change_bonus_uc");
    if (this.accountBalanceHistory && this.accountBalanceHistory.length <= 0)
      this.getAccountBalanceHistory(this.consumerUnit.id);

    this.loadingPermission = false;
  },

  async mounted() {
    if (this.plans?.length <= 0) this.getAllPlans();
    if (this.contracts && this.contracts.length <= 0)
      this.getContractsByUC(this.consumerUnit.id);
    if (this.consumerUnit.under_analysis) {
      this.under_analysis_reason = this.consumerUnit.under_analysis_reason;
      this.under_analysis_comments = this.consumerUnit.under_analysis_comments;
    }
  },

  watch: {
    plan() {
      this.consumerUnit.percentage_discount = this.plan?.discount;
    },
    consumerUnit() {
      this.getContractsByUC(this.consumerUnit.id);
    },
    "consumerUnit.id"() {
      this.under_analysis_reason =
        this.consumerUnit?.under_analysis_reason || null;
      this.under_analysis_comments =
        this.consumerUnit?.under_analysis_comments || null;
    },
    editBalance() {
      if (!this.editBalance) this.$refs.accountBalanceForm.reset();
    },
    accountBalanceCategory() {
      if (this.editBalance)
        this.accountBalanceDescription = this.accountBalanceCategory.text;
    },
  },

  computed: {
    ...mapGetters("cs", ["userCS", "filteredBillings"]),
    ...mapGetters("sales", ["plansByUtilityCompany", "filteredPlans"]),
    ...mapGetters("qualification", ["qualifications"]),
    ...mapGetters(["loggedUser"]),
    ...mapState("sales", ["subclasses ", "plans"]),
    ...mapState("cs", ["contracts", "accountBalanceHistory"]),
    ...mapState(["user", "permissions", "plans"]),
    ...mapState(["permissions"]),

    consumerUnit() {
      if (this.$store.state && this.$store.state.cs.consumerUnit)
        return this.$store.state.cs.consumerUnit;
      else return null;
    },
    consumerUnits() {
      if (this.$store.state && this.$store.state.cs.consumerUnits)
        return this.$store.state.cs.consumerUnits;
      else return [];
    },
    address() {
      if (!this.consumerUnit.address) return "";
      let address = this.consumerUnit.address.address;

      if (this.consumerUnit.address && this.consumerUnit.address.address_number)
        address = address + ", " + this.consumerUnit.address.address_number;

      if (
        this.consumerUnit.address &&
        this.consumerUnit.address.address_complement
      )
        address =
          address + " - " + this.consumerUnit.address.address_complement;

      return address;
    },
    address_complement() {
      if (this.consumerUnit.address && !this.consumerUnit.address.district)
        return "";
      let address = this.consumerUnit.address.district.toUpperCase();

      if (this.consumerUnit.address && this.consumerUnit.address.city)
        address = address + ", " + this.consumerUnit.address.city.toUpperCase();

      if (
        this.consumerUnit.address &&
        this.consumerUnit.address.state &&
        this.consumerUnit.address.state.initials
      )
        address =
          address +
          " - " +
          this.consumerUnit.address.state.initials.toUpperCase();

      return address;
    },
    address_postalcode() {
      if (!this.consumerUnit.address && !this.consumerUnit.address.postal_code)
        return "";
      return this.consumerUnit.address.postal_code;
    },

    status() {
      if (this.consumerUnit.status === "activated") {
        return {
          icon: "check_box",
          text: "ATIVA",
          color: "green",
        };
      } else if (this.consumerUnit.status === "canceling") {
        return {
          icon: "check_box_outline_blank",
          text: "EM CANCELAMENTO",
          color: "orange",
        };
      } else if (this.consumerUnit.status === "awaiting_review_documents") {
        return {
          icon: "check_box_outline_blank",
          text: "REVISÃO DE DOCUMENTOS",
          color: "orange",
        };
      } else if (this.consumerUnit.status === "awaiting_signature") {
        return {
          icon: "check_box_outline_blank",
          text: "AGUARDANDO ASSINATURA",
          color: "orange",
        };
      } else if (
        this.consumerUnit.status === "canceled" ||
        this.consumerUnit.status.toLowerCase() === "inactivated"
      ) {
        return {
          icon: "check_box_outline_blank",
          text: "CANCELADA",
          color: "red",
        };
      } else {
        return {
          icon: "indeterminate_check_box",
          text: this.consumerUnit.status,
          color: "grey",
        };
      }
    },
    contract_id() {
      if (!this.consumerUnit.contract_id) return false;
      return (
        "https://painel.autentique.com.br/documentos/" +
        this.consumerUnit.contract_id
      );
    },

    allocationStatus() {
      if (this.consumerUnit.allocation_status === "active") {
        return {
          icon: "check_box",
          text: "ATIVA",
          color: "green",
        };
      } else if (
        this.consumerUnit.allocation_status === "awaiting_distribution"
      ) {
        return {
          icon: "check_box_outline_blank",
          text: "AGUARDANDO DISTRIBUIÇÃO",
          color: "orange",
        };
      } else if (
        this.consumerUnit.allocation_status === "awaiting_powerplant"
      ) {
        return {
          icon: "check_box_outline_blank",
          text: "AGUARDANDO ALOCAÇÃO DE USINA",
          color: "orange",
        };
      } else if (this.consumerUnit.allocation_status === "awaiting_billing") {
        return {
          icon: "check_box_outline_blank",
          text: "AGUARDANDO FATURAMENTO",
          color: "orange",
        };
      } else {
        return {
          icon: "indeterminate_check_box",
          text: this.consumerUnit.allocation_status,
          color: "grey",
        };
      }
    },

    comercialStatus() {
      if (this.consumerUnit.comercial_status === true) {
        return {
          icon: "check_box_outline_blank",
          text: "COMERCIAL",
          color: "purple",
        };
      } else {
        return null;
      }
    },
    filteredBalanceCategories() {
      if (this.accountBalanceType === "bonus")
        return this.accountBalanceCategories.filter((c) => c.type === "bonus");
      else
        return this.accountBalanceCategories.filter((c) => c.type === "charge");
    },
  },

  methods: {
    ...mapActions("cs", [
      "updateUser",
      "updateConsumerUnit",
      "getContractsByUC",
      "getAccountBalanceHistory",
      "getBillings",
    ]),
    ...mapActions("qualification", ["getQualifications"]),
    ...mapActions("sales", ["getAllPlans"]),

    updatePlans() {
      let available_plans = this.filteredPlans({
        person_type: this.consumerUnit?.person_type,
        company: this.consumerUnit?.company,
        utility_company: this.consumerUnit?.utility_company,
      });
      const sales_partner =
        this.user?.group?.includes("sales_partner") ||
        this.user?.group?.includes("sales_partner_management");
      const board = this.user?.group?.includes("board");
      const customer_care = this.user?.group?.includes("customer_care");
      if (this.loggedUser) {
        if (sales_partner || board || customer_care) {
          available_plans = available_plans.filter(
            (plan) => plan.promotional === false,
          );
        }
      }
      // Faz um filter para checar os planos em que o tempo de contrato são maiores que o atual, caso a UC possua plano
      const blocked_status = ["activated", "interrupting", "canceling"];
      if (
        this.consumerUnit?.plan &&
        blocked_status.includes(this.consumerUnit?.status)
      ) {
        let otherPlans = available_plans.filter(
          (plan) =>
            plan?.contract_time >= this.consumerUnit?.plan?.contract_time,
        );
        available_plans = otherPlans;
      }
      let userPlan;
      if (
        this.user?.plan &&
        this.consumerUnit?.person_type == this.user?.person_type &&
        this.consumerUnit?.utility_company == this.user?.utility_company
      ) {
        userPlan = this.user?.plan;
      }

      const selectedPlan = this.consumerUnit?.plan || userPlan || null;
      this.plan = selectedPlan;
      if (
        this.plan &&
        !available_plans?.find((item) => item?.id == this.plan?.id)
      ) {
        available_plans.push(this.plan);
      }
    },
    changePlan() {
      this.$refs.changeUcPlan.showModal(this.consumerUnit.plan);
      console.log(this.consumerUnit.plan.name);
    },

    async cancelConsumerUnitProcess() {
      if (!this.$refs["consumerUnitStatus"].validate()) {
        return false;
      }
      this.loadingChange = true;
      await cancelConsumerUnit({
        id: this.consumerUnit.id,
        reason: this.reason,
        reason_description: this.reasonDescription,
        service_id: this.serviceId,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
        check_obligations: true,
      })
        .then(() => {
          this.cancelDialog = false;
          this.showSnackBar(
            "Unidade Consumidora colocada em processo de cancelamento com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.cancelDialog = false;
          if (err.response.data.error === "has_obligations") {
            console.log("error", err.response.data.error);
            this.showSnackBar(err.response.data.message, "top", "red");
          } else if (err.response.data && err.response.data.message) {
            this.showSnackBar(
              "Erro ao cancelar a unidade consumidora. " +
                err.response.data.message,
              "top",
              "red",
            );
          } else {
            this.showSnackBar(
              "Erro ao cancelar a unidade consumidora. Tente novamente mais tarde. ",
              "top",
              "red",
            );
          }
        });
      this.loadingChange = false;
    },

    async multa() {
      this.cancelDialog = true;
      try {
        let fine = await getFine(this.consumerUnit.id, null);

        this.tempoAtivo = fine.active_time;
        this.tempoContrato = fine.contract_time;
        this.valorMulta = fine.amount;
        this.mesesMulta = fine.amount_months_fine;
        this.hasFine = fine.fine;
      } catch (err) {
        this.showSnackBar(
          "Erro ao calcular multa, contate o setor de tecnologia.",
          "top",
          "warning",
        );
        console.log(err);
      }
    },

    async reactivateConsumerUnitProcess() {
      this.loadingChange = true;
      await reactivateConsumerUnit({
        id: this.consumerUnit.id,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
      })
        .then(() => {
          this.reactivateDialog = false;
          this.showSnackBar(
            "Unidade Consumidora colocada em processo de reativação com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.reactivateDialog = false;
          this.showSnackBar(
            "Erro ao reativar a unidade consumidora. " +
              err.response.data.message,
            "top",
            "red",
          );
        });
      this.loadingChange = false;
    },

    async ucs_selected(consumer_unit) {
      this.loading_qualification = true;
      await initQualification(
        this.userCS.cpf,
        this.userCS.id,
        [consumer_unit.installation_number],
        "reactivation",
        true,
        null,
        consumer_unit.utility_company,
        null,
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            this.qualification_ids = ret.data.ids;
            const params = {
              cpf: this.userCS.cpf,
              qualification_ids: this.qualification_ids,
            };
            this.getQualifications(params);
          } else {
            this.showSnackBar(
              "Erro ao iniciar qualificação.",
              "top",
              "warning",
            );
          }
        })
        .catch((err) => {
          this.showSnackBar(
            `Erro ao iniciar qualificação. ${
              err && err.response ? err.response.data : ""
            }`,
            "top",
            "warning",
          );
        });
      this.loading_qualification = false;
    },

    async finishQualificationProcess() {
      await finishQualification(
        this.userCS.cpf,
        this.userCS.id,
        this.qualification_ids,
        null,
        null,
        null,
        null,
        null,
        null,
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            let result = ret.data.results[ret.data.results.length - 1];
            let uc_added = !result ? false : result.consumer_unit_added;
            if (!uc_added) {
              this.showSnackBar(
                "Erro ao adicionar unidade consumidora! " + result.message,
                "top",
                "error",
              );
            } else {
              this.showSnackBar(
                "Unidade consumidora adicionada com sucesso!",
                "top",
                "green",
              );
            }
          } else {
            this.showSnackBar(
              "Erro ao adicionar unidade consumidora! " + ret.data,
              "top",
              "error",
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.showSnackBar(
            `Erro ao adicionar unidade consumidora! ${
              err && err.response ? err.response.data : ""
            }`,
            "top",
            "error",
          );
        });
    },

    async setDuplicatedSupply(consumer_unit_id, value) {
      try {
        const res = await updateConsumerUnitCore(consumer_unit_id, {
          // TODO: Necessário colocar motivo?
          // change_reason: observation,
          duplicated_supply: value,
        });

        if (res.data.code == "success") {
          this.showSnackBar("Alteração salva com sucesso!", "top", "green");
          this.editDuplicatedSupply = false;
        } else {
          this.showSnackBar(
            "Não foi possivel salvar a alteração",
            "top",
            "red",
          );
          this.editDuplicatedSupply = false;
        }
      } catch (err) {
        console.error(err);
        this.showSnackBar(JSON.stringify(err), "top", "red");
        this.editDuplicatedSupply = false;
      }
    },

    async setWithoutBalance(consumer_unit_id, value) {
      try {
        const permission = await getPermission("without_balance", this.user.id);

        if (!permission.data.has_permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          return false;
        }
      } catch (err) {
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      let baseData = {
        without_balance: value,
        without_balance_last_agent: this.user.email,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
        updated_at: new Date(),
      };

      let data = value
        ? {
            ...baseData,
            status: "interrupted",
            without_balance_agent: this.user.email,
            without_balance_at: new Date(),
          }
        : baseData;

      try {
        await updateConsumerUnit(consumer_unit_id, data);
        this.showSnackBar("Alteração salva com sucesso!", "top", "green");
        this.editWithoutBalance = false;
      } catch (err) {
        console.error(err);
        this.showSnackBar("Erro ao realizar a marcação", "top", "red");
        this.editWithoutBalance = false;
      }
    },

    async setUnderAnalysis(consumer_unit, value) {
      this.loading_under_analysis = true;
      try {
        this.loading_under_analysis = true;
        const permission = await getPermission(
          "uc_under_analysis",
          this.user.id,
        );

        if (!permission.data.has_permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loading_under_analysis = false;
          return false;
        }
      } catch (err) {
        this.loading_under_analysis = false;
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      if (value && !this.under_analysis_reason) {
        this.loading_under_analysis = false;
        this.showSnackBar("Informe o motivo da alteração!", "top", "red");
        return;
      }

      if (
        value &&
        this.under_analysis_reason === "other_reasons" &&
        !this.under_analysis_comments
      ) {
        this.loading_under_analysis = false;
        this.showSnackBar("Informe as observações!", "top", "red");
        return;
      }

      let data = {
        under_analysis: value,
        under_analysis_last_agent: this.user.email,
        updated_at: new Date(),
        under_analysis_reason: this.under_analysis_reason || null,
        under_analysis_comments: this.under_analysis_comments || null,
      };

      let under_analysis_history = consumer_unit?.under_analysis_history || [];
      under_analysis_history.push({
        agent_email: this.user.email,
        action: value ? "UC colocada em análise" : "UC retirada de análise",
        under_analysis_reason: value ? this.under_analysis_reason : null,
        under_analysis_comments: value ? this.under_analysis_comments : null,
        created_at: new Date(),
      });
      data.under_analysis_history = under_analysis_history;

      try {
        this.editUnderAnalysis = false;
        this.loading_under_analysis = false;
        await updateConsumerUnit(consumer_unit.id, data);
        this.showSnackBar("Alteração salva com sucesso!", "top", "green");
      } catch (err) {
        console.error(err);
        this.showSnackBar("Erro ao realizar alteração!", "top", "red");
      }
    },

    async changeConsumerUnit() {
      if (!this.$refs[this.editTarget].validate()) {
        return false;
      }
      this.loadingChange = true;
      await updateConsumerUnit(this.consumerUnit.id, {
        [this.editTarget]: this.editValue,
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
      })
        .then(() => {
          this.editDialog = false;
          this.loadingChange = false;
          this.showSnackBar("Campo alterado com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.editDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao alterar campo. Tente novamente mais tarde. " + err,
            "top",
            "red",
          );
          console.error(err);
        });
    },

    async changeCredentials() {
      try {
        this.loadingChange = true;
        const permission = await getPermission("edit_cpf_cnpj", this.user.id);

        if (!permission.data.has_permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loadingChange = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      if (!this.$refs[this.editTarget].validate()) {
        return false;
      }

      try {
        const data = {
          [this.editTarget]: this.editValue,
        };
        await updateConsumerUnitCore(this.consumerUnit.id, data);
        this.editCredentials = false;
        this.editTarget = "";
        this.editValue = "";
        this.loadingChange = false;
        this.showSnackBar("Campo alterado com sucesso!", "top", "green");
      } catch (err) {
        this.editCredentials = false;
        this.editTarget = "";
        this.editValue = "";
        this.loadingChange = false;
        this.showSnackBar(
          "Erro ao alterar campo. Tente novamente mais tarde. " + err,
          "top",
          "red",
        );
      }
    },

    async changeAccountBalance() {
      if (this.$refs.accountBalanceForm.validate()) {
        this.loadingChange = true;

        let bonus = +this.accountBalance.replace(",", ".");

        if (this.accountBalanceType === "charge") {
          bonus = bonus * -1;
        }

        try {
          await addAccountBalance(
            bonus,
            this.accountBalanceCategory.value,
            this.accountBalanceReason,
            this.accountBalanceDescription,
            this.consumerUnit.id,
          );

          this.showSnackBar(
            "Balanço Financeiro atualizado com sucesso!",
            "top",
            "green",
          );
        } catch (err) {
          this.showSnackBar(
            "Erro ao alterar campo. Tente novamente mais tarde. " + err,
            "top",
            "red",
          );
          console.error(err);
        }

        this.editBalance = false;
        this.loadingChange = false;
      }
    },

    async changeAddress() {
      this.loadingChange = true;
      let data = {
        address: {
          address:
            this.newAddress != ""
              ? this.newAddress
              : this.consumerUnit.address.address || null,
          address_complement:
            this.newAddressComplement != ""
              ? this.newAddressComplement
              : this.consumerUnit.address.address_complement || null,
          address_number:
            this.newAddressNumber != ""
              ? this.newAddressNumber
              : this.consumerUnit.address.address_number || null,
          city:
            this.newCity != ""
              ? this.newCity
              : this.consumerUnit.address.city || null,
          district:
            this.newDistrict != ""
              ? this.newDistrict
              : this.consumerUnit.address.district || null,
          postal_code:
            this.newPostalCode != ""
              ? this.newPostalCode
              : this.consumerUnit.address.postal_code || null,
          country: {
            initials: "BR",
            name: "Brasil",
          },
          state: {
            initials: "MG",
            name: "Minas Gerais",
          },
        },
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
      };
      await updateConsumerUnit(this.consumerUnit.id, data)
        .then(() => {
          this.editAddressDialog = false;
          this.newPostalCode = "";
          this.newAddress = "";
          this.newAddressNumber = "";
          this.newAddressComplement = "";
          this.newDistrict = "";
          this.newCity = "";
          this.loadingChange = false;
          this.showSnackBar("Campo(s) alterado com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.editAddressDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao alterar campo(s). Tente novamente mais tarde. " + err,
            "top",
            "red",
          );
        });
    },

    setUniqueBilling(id, boolUniqueBilling) {
      this.loadingChange = true;
      let data = {
        unique_billing: boolUniqueBilling,
      };
      let account_unification_history =
        this.consumerUnit.account_unification_history || [];
      account_unification_history.push({
        agent_email: this.user.email,
        action: boolUniqueBilling
          ? "A conta foi unificada"
          : "A conta foi desunificada",
        created_at: new Date(),
      });
      data.account_unification_history = account_unification_history;
      this.updateConsumerUnit({
        id: id,
        data,
      })
        .then(() => {
          this.loadingChange = false;
          this.editUniqueBilling = false;
          this.showSnackBar("Alteração realizada com sucesso", "top", "green");
        })
        .catch((err) => {
          this.loadingChange = false;
          this.editUniqueBilling = false;
          this.showSnackBar("Erro ao realizar alteração" + err, "top", "red");
        });
    },

    async showforceUcCancellation(uc) {
      await this.getBillings(uc);
      this.forceCancellationDialog = true;
    },

    async forceUcCancellation(uc) {
      this.loading_force_uc_cancellation = true;

      // checa permissão
      try {
        const permission = await getPermission(
          "force_uc_cancellation",
          this.user.id,
        );

        if (!permission.data.has_permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loading_force_uc_cancellation = false;
          return false;
        }
      } catch (err) {
        this.loading_force_uc_cancellation = false;
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      //verficar se o usuário deseja abonar faturas
      if (this.setStatusFree.length > 0) {
        if (!this.free_reason) {
          this.showSnackBar(
            "Descreva o motivo para abonar as faturas!",
            "top",
            "red",
          );
          this.loading_force_uc_cancellation = false;
          return;
        }

        const billing_ids = this.setStatusFree.map((b) => b.id);
        for (const billingID of billing_ids) {
          try {
            await firestore.collection("billing").doc(billingID).update({
              status: "free",
              free_reason: this.free_reason,
              free_approved_at: new Date(),
              free_approved_by: this.user.email,
              updated_at: new Date(),
            });
            removeTransaction(billingID);
          } catch (err) {
            this.loading_force_uc_cancellation = false;
            this.showSnackBar(
              "Erro ao abonar fatura(s). " + err.response.data.error.message,
              "top",
              "red",
            );
            console.error(err.response.data.error);
            return;
          }
        }
      }

      //força o cancelamento
      if (!this.forced_cancellation_reason_description) {
        this.showSnackBar(
          "Descreva o motivo para forçar o cancelamento",
          "top",
          "red",
        );
        this.loading_force_uc_cancellation = false;
        return;
      }

      this.updateConsumerUnit({
        id: uc.id,
        data: {
          status: "canceled",
          forced_canceling: true,
          billing_competence_end: moment().format("YYYY-MM"),
          status_reason: "sale_analysis",
          status_reason_description:
            this.forced_cancellation_reason_description,
          last_agent_id: this.user.id,
          last_agent_name: this.user.name,
          last_agent_email: this.user.email,
          cancel_agent: this.user.email,
          canceled_at: new Date(),
          updated_at: new Date(),
        },
      })
        .then(() => {
          this.loading_force_uc_cancellation = false;
          this.forceCancellationDialog = false;
          this.showSnackBar(
            "Cancelamento forçado realizado com sucesso",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.loading_force_uc_cancellation = false;
          this.showSnackBar(
            "Falha ao realizar cancelamento forçado " + err,
            "top",
            "red",
          );
        });
    },

    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },

    downloadContracts(contract_url) {
      if (contract_url) {
        let url = "gs://enercred.appspot.com/" + contract_url;
        const resumeRef = firebase.storage().refFromURL(url);
        resumeRef
          .getDownloadURL()
          .then((downloadUrl) => {
            const anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.target = "_blank";
            anchor.click();
            document.body.removeChild(anchor);
          })
          .catch((error) => {
            switch (error.code) {
              case "storage/object-not-found":
                this.showSnackBar(
                  "Não foi encontrado nenhum contrato para este membro!",
                  "top",
                  "orange",
                );
                break;

              case "storage/unauthorized":
                this.showSnackBar(
                  "Não possui permissão para acessar esse contrato!",
                  "top",
                  "orange",
                );
                break;

              case "storage/canceled":
                this.showSnackBar(
                  "Erro ao fazer dowload do contrato!",
                  "top",
                  "orange",
                );
                break;

              case "storage/unknown":
                this.showSnackBar(
                  "Não foi encontrado nenhum contrato para este membro!",
                  "top",
                  "orange",
                );
                break;
              case "storage/invalid-argument":
                this.showSnackBar(
                  "Não foi encontrado nenhum contrato para este membro!",
                  "top",
                  "orange",
                );
                break;
              default:
                break;
            }
          });
      } else {
        this.showSnackBar(
          "Não foi encontrado nenhum contrato para este membro!",
          "top",
          "orange",
        );
      }
    },

    selectText(item) {
      const competence = item.competence.substring(0, 7);
      return (
        competence +
        " — R$" +
        (item.total || 0).toFixed(2) +
        " — " +
        this.formatStatus(item)
      );
    },

    formatStatus(billing) {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() - 1);

      if (billing.status === "") return "xxx";
      else if (billing.status === "paid" || billing.status === "succeeded")
        return "Paga";
      else if (billing.status === "pending") return "Processar";
      else if (billing.status === "refused") return "Recusada";
      else if (billing.status === "pending_approval") return "Em Análise";
      else if (billing.status === "reprocessing") return "Reprocessando";
      else if (billing.status === "generating") return "Gerando";
      else if (billing.status === "opened") return "Aberto";
      else if (billing.status === "canceled") return "Expirado";
      else if (billing.status === "overdue") return "Atrasada";
      else if (billing.status === "generation_failed") return "Falha ao gerar";
      else if (billing.status === "validation_failed") return "Inválido";
      else if (billing.status === "in_queue") return "Programado";
      else if (billing.status === "error") return "Erro";
      else if (billing.status === "free") return "Abonado";
      else if (billing.status === "refunded") return "Reembolsado";
      else if (billing.status === "negotiated") return "Negociado";
      else if (billing.status === "parceled") return "Parcelado";
      else if (billing.status === "waiting_payment") return "Aberta";
      else if (billing.status === "free_pending") return "Pendente para Abono";
      else if (billing.status === "postponed")
        return "O valor da fatura será cobrado nas próximas faturas";
      else return billing.status;
    },

    copyLink(sign_url) {
      navigator.clipboard.writeText(sign_url);
      this.showSnackBar("Copiado para a área de transferência", "top", "green");
    },

    showAnalysisHistoryDialog() {
      this.analysisHistoryDialog = !this.analysisHistoryDialog;
    },

    showAccountUnificationHistory() {
      this.accountUnificationHistoryDialog =
        !this.accountUnificationHistoryDialog;
    },

    async fetchReasons() {
      try {
        const snapshot = await firestore.collection("je_tabulation").get();
        const allReasons = snapshot.docs.map((doc) => doc.data());
        this.reasonsList = allReasons.filter((reason) =>
          reason.owners.some((owner) => this.user.group.includes(owner)),
        );
      } catch (error) {
        console.error("Erro ao buscar os motivos: ", error);
      }
    },
  },

  filters: {
    formatDateTime: (date) => {
      if (!date || date === "") return "";
      if (typeof date === "string") return moment(date).format("DD/MM/YYYY");
      else return moment(date.toDate()).format("DD/MM/YYYY HH:mm");
    },

    formatContractStatus: (value) => {
      if (!value) return "Sem Status";

      if (value.toLowerCase() === "signed") {
        return "Assinado";
      } else if (value.toLowerCase() === "awaiting_signature") {
        return "Aguardando Assinatura";
      } else if (value.toLowerCase() === "rejected") {
        return "Rejeitado";
      }
    },

    formatContractStatusColor: (value) => {
      if (!value) return "grey darken-2";

      if (value.toLowerCase() === "signed") {
        return "green";
      } else if (value.toLowerCase() === "awaiting_signature") {
        return "yellow darken-2";
      } else if (value.toLowerCase() === "rejected") {
        return "red";
      }
    },

    formatContractURL: (contract_id) => {
      if (!contract_id) return "-";
      return "https://painel.autentique.com.br/documentos/" + contract_id;
    },

    formatCategoryType: (category) => {
      if (!category || category === "") return "Sem categoria";
      switch (category) {
        case "duplicated_payment":
          return "Pagamento em duplicidade";
        case "marketing":
          return "Marketing";
        case "utility_interest":
          return "Juros de concessionária";
        case "greater_payment":
          return "Pagamento maior";
        case "retention":
          return "Retenção";
        case "general":
          return "Sem catetoria";
        default:
          return "Sem catetoria";
      }
    },

    formatBalanceType: (type) => {
      if (!type || type === "") return "Sem tipo";
      if (type === "credit") return "Entrada";
      else return "Saída";
    },

    formatBalanceTypeColor: (type) => {
      if (!type || type === "") return "Grey darken-2";
      if (type === "credit") return "green";
      else return "red";
    },

    formatMoney: (value) => {
      if (!value) return "-";
      return "R$ " + value.toFixed(2).replace(".", ",");
    },

    formatUtilityCompany: (value) => {
      if (!value) return "-";
      if (value === "cemig") return "CEMIG";
      if (value === "neoenergia-pe") return "Neoenergia Pernambuco";
      if (value === "cpfl-piratininga") return "CPFL Piratininga";
      if (value === "neoenergia-ba") return "Neoenergia Bahia";
      return value;
    },

    formatAnalysisReason: (reason) => {
      if (!reason) return "Sem motivo";
      if (reason === "outdated_account") return "Conta desatualizada";
      if (reason === "wrong_personal_data") return "Dados pessoais incorretos";
      if (reason === "wrong_account_data") return "Dados da conta incorretos";
      if (reason === "other_reasons") return "Outros (Especificar)";
      if (reason === "no_account") return "Sem anexo da conta";
      if (reason === "no_holder_doc")
        return "Sem anexo dos documentos do titular";
      if (reason === "no_pj_doc") return "Sem anexo da documentação PJ";
      if (reason === "account_error") return "Conta inelegível ou incompleta";
      if (reason === "possible_debts")
        return "Possíveis débitos com a concessionária";
      if (reason === "contract_termination")
        return "Encerramento de contrato na concessionária";
      if (reason == "change_of_holder") return "Troca de titularidade";
      return reason;
    },
  },
};
</script>

<style scoped>
.dialog-container {
  position: relative;
}

.dialog-header {
  position: absolute;
  width: 100%;
  height: 60px;
  top: 0;
  z-index: 2;
}

.dialog-close-btn {
  position: absolute;
  right: 0;
  top: 0;
}

.dialog-content {
  margin-top: 56px;
  overflow-y: auto;
  max-height: calc(100vh - 160px);
}
</style>
